export default __webpack_public_path__ + "static/media/1.54f407e1.jpg";